module.exports = new __parcel__URL__("background-dark.46d9946a.svg").toString();